<template>
  <v-container fluid class="pa-2">

    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>
    
    
    <!-- NEWS ITEMS -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="!isLoading && translatedNews.length">
      
      <template v-for="item in translatedNews">
        <div v-if="item.translation" class="ma-0 pa-2" :class="'col-' + (12 / columns)" :key="item.identifier">
          <v-card
              height="100%"
              link
              flat
              class="rounded-lg d-flex flex-column link-on-hover"
              hover
              @click.prevent="openItem(item)"
          >
            <v-img
                v-if="item.translation.thumbnailUrl"
                :src="item.translation.thumbnailUrl"
                lazy-src="/assets/img/placeholder.png"
                :aspect-ratio="16/9"
                class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
                eager
                cover
            ></v-img>
            <v-img
                v-else-if="item.thumbnailUrl"
                :src="item.thumbnailUrl"
                lazy-src="/assets/img/placeholder.png"
                :aspect-ratio="16/9"
                class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
                eager
                cover
            ></v-img>
            <v-card-title class="text-break"><strong>{{ item.translation.title }}</strong></v-card-title>
            <v-card-text class="fill-height">
              <div v-if="item.translation.shortDescription" v-html="item.translation.shortDescription"></div>
            </v-card-text>
          </v-card>
        </div>
      </template>

    </div>
    
    
    <!-- NEWS ITEM DIALOG -->
    <v-dialog
        v-model="showItemDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-img
            v-if="selectedItem.translation && selectedItem.translation.thumbnailUrl"
            :src="selectedItem.translation.thumbnailUrl"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
            :aspect-ratio="16/9"
            class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
            eager
            cover
        ></v-img>
        <v-img
            v-else-if="selectedItem.thumbnailUrl"
            :src="selectedItem.thumbnailUrl"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
            :aspect-ratio="16/9"
            class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
            eager
            cover
        ></v-img>
        <v-btn
            class="mt-3"
            color="primary"
            fab
            depressed
            dark
            small
            absolute
            right
            @click.prevent="showItemDialog = false"
        >
          <v-icon small>fal fa-close</v-icon>
        </v-btn>
        <v-card-title v-if="selectedItem.translation && selectedItem.translation.title" class="text-break"><strong>{{ selectedItem.translation.title }}</strong></v-card-title>
        <v-card-text class="fill-height">
          <div v-if="selectedItem.translation && selectedItem.translation.description" v-html="selectedItem.translation.description"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </v-container>
</template>

<script>

import api from "@/api/api";

export default {
  name: "m2h-news",
  data() {
    return {
      isLoading: true,
      newsfeed: [],
      newsV2: [],
      showItemDialog: false,
      selectedItem: {}
    }
  },
  
  computed: {
    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 4;
      }

      if (this.$vuetify.breakpoint.lg) {
        return 3;
      }

      if (this.$vuetify.breakpoint.md) {
        return 3;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 2;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 1;
      }

      return 1;
    },

    translatedNews() {
      let news = [...this.newsV2]
      news.forEach((news) => {
        news.translation = null
        if (news.translations && news.translations.length){
          if (news.translations.find((t) => t.language === this.$i18n.locale)){
            news.translation = news.translations.find((t) => t.language === this.$i18n.locale)
          }
        }
      })
      return news
    }

  },

  mounted(){
    //this.fetchNewsfeed()
    this.fetchNews()
  },

  methods: {
    async fetchNewsfeed(){
      this.isLoading = true
      let newsfeed = []
      newsfeed = await api.newsItems.getList("newsfeed", this.$i18n.locale).then((res) => { return res.data })
      if (newsfeed.length){
        this.newsfeed = newsfeed.sort((a, b) => {
          return this.$moment(a.created).unix() - this.$moment(b.created).unix()
        })
        for (const item of this.newsfeed) {
          let image = await this.fetchImage(item.imageAssetId)
          let thumbnail = await this.fetchImage(item.thumbnailAssetId)
          item.image = image
          item.thumbnail = thumbnail
        }
      }
      this.isLoading = false
    },

    async fetchNews(){
      this.isLoading = true
      let news = []
      news = await api.news.getList().then((res) => { return res.data })
      if (news.length){
        this.newsV2 = news.sort((a, b) => {
          return this.$moment(b.visibleFrom).unix() - this.$moment(a.visibleFrom).unix()
        })
      }
      this.isLoading = false
    },

    async fetchImage(id){
      if (id){
        return await api.newsItems.getSas(id)
            .then((res) => {
              return res.data
            })
            .catch(() => {
              return ''
            })
      } else {
        return ''
      }
    },
    
    openItem(item){
      this.selectedItem = item
      this.showItemDialog = true
        this.$root.$emit('post-news-opened', { id: item.identifier })
    }
  }
}
</script>

<style scoped>

</style>
